module.exports = __webpack_public_path__ + "img/props-zh_tw.de9acb60.png";